/**
 * Mimicked functionality found in the PPN Web Enrollment Tool
 * https://github.com/security-first-managers/sfi-ppn-web-enrollment/blob/d9a4b1aae8895c333a3908da5472f59451829f29/client/src/app/common/services/browser-detector.service.js
 */

export default {
  // Internet Explorer 8-11
  isIE: !!document.documentMode,
  isUnsupported: document.documentMode < 11,
  isEdge: window.navigator.userAgent.indexOf('Edge/') > -1
};



// WEBPACK FOOTER //
// ./src/services/BrowserEvalService.js